import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { addFooterNotification, deleteFooterNotification } from 'actions/notifications.js';

const useNotifications = () => {
  const dispatch = useDispatch();

  const handleFooterNotification = useCallback(
    ({
      title,
      message = '',
      type = 'default',
      action = null,
      actionText = null,
      autoHide = true,
      // How long an auto-hiding notification stays up. Omitted by almost every
      // caller — worth setting only when the message takes longer to read than
      // the default allows.
      delay,
      dataTestId = null,
      actionOnClose = null,
    }) => {
      dispatch(addFooterNotification({ title, message, type, action, actionText, autoHide, delay, dataTestId, actionOnClose }));
    },
    [dispatch],
  );

  const clearFooterNotification = useCallback(() => {
    dispatch(deleteFooterNotification());
  }, [dispatch]);

  return { handleFooterNotification, clearFooterNotification };
};

export default useNotifications;
